import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { DeviceTag } from '@kentik/ui-shared/dictionary/types';
import { deviceTagsQuery } from 'app/stores/dictionary/raw/deviceTags';

export const useDeviceTags = (): UseQueryResult<DeviceTag[], Error> => useQuery(deviceTagsQuery);
